import { motion } from "framer-motion";
import { Bell, Book, Award, Wallet, Cpu, Apple } from "lucide-react";

const FEATURES = [
  { icon: Bell, title: "Alertas en tiempo real", desc: "Señales Lanza de Neptuno + análisis pre/post market." },
  { icon: Book, title: "Bitácoras inteligentes", desc: "Feedback con IA y próximos pasos de mejora." },
  { icon: Award, title: "Rangos y medallas", desc: "Progreso visual con insignias de potencial NFT." },
  { icon: Wallet, title: "Wallet de recompensas", desc: "Bonos, beneficios y retiros desde la app." },
  { icon: Cpu, title: "Ecosistema en expansión", desc: "IA, bots y módulos integrados con el tiempo." },
];

export default function AppMovil() {
  return (
    <section className="relative py-24 md:py-32 bg-black overflow-hidden" data-testid="app-movil-section">
      <div className="absolute inset-0 radial-green opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
            / App Móvil HONOR
          </span>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
            Tu cuartel digital <span className="italic text-[#BEDD7D]">24/7</span>.
          </h2>
          <p className="mt-6 text-white/70 font-body text-lg leading-relaxed">
            Notificaciones de análisis, bitácoras con feedback, metas de rango y wallet de
            recompensas. Todo en tu bolsillo.
          </p>

          <div className="mt-10 flex flex-col gap-3">
            {FEATURES.map((f) => (
              <div
                key={f.title}
                className="flex items-start gap-4 p-4 rounded-xl border border-[#3E4D36]/40 bg-[#1A2E1A]/20 hover:border-[#BEDD7D]/50 hover:bg-[#1A2E1A]/40 transition-all"
                data-testid={`app-feature-${f.title.toLowerCase().replace(/ /g, "-")}`}
              >
                <div className="w-9 h-9 shrink-0 rounded-lg bg-black border border-[#BEDD7D]/30 flex items-center justify-center">
                  <f.icon className="w-4 h-4 text-[#BEDD7D]" />
                </div>
                <div>
                  <div className="font-display font-bold text-white uppercase text-sm tracking-wide">
                    {f.title}
                  </div>
                  <div className="mt-0.5 text-sm text-white/60 font-body">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-[#3E4D36] bg-black/50 text-white/80">
              <Apple className="w-4 h-4 text-[#BEDD7D]" />
              <div className="flex flex-col leading-none">
                <span className="text-[9px] font-body uppercase tracking-widest text-white/50">
                  Próximamente en
                </span>
                <span className="font-display font-bold text-sm">App Store</span>
              </div>
            </div>
            <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-[#3E4D36] bg-black/50 text-white/80">
              <svg className="w-4 h-4 text-[#BEDD7D]" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12M20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.53 12.9 20.18 13.18L17.89 14.5L15.39 12L17.89 9.5L20.16 10.81M6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z" />
              </svg>
              <div className="flex flex-col leading-none">
                <span className="text-[9px] font-body uppercase tracking-widest text-white/50">
                  Próximamente en
                </span>
                <span className="font-display font-bold text-sm">Google Play</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Phone mockup */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative flex justify-center"
        >
          <div className="relative w-[280px] md:w-[320px] aspect-[9/19] rounded-[3rem] bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] p-2 shadow-[0_30px_80px_rgba(190,221,125,0.25)] border border-[#2a2a2a]">
            <div className="relative w-full h-full rounded-[2.5rem] bg-black overflow-hidden flex flex-col">
              <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-6 bg-black rounded-b-2xl z-20" />
              {/* Status bar */}
              <div className="flex items-center justify-between px-6 pt-4 pb-2 text-[10px] font-display text-white/80">
                <span>9:41</span>
                <span>●●●</span>
              </div>
              {/* App header */}
              <div className="px-5 pt-8 pb-4 border-b border-[#3E4D36]/30">
                <div className="text-[9px] font-display uppercase tracking-widest text-[#BEDD7D]">
                  Buenos días, Guajit
                </div>
                <div className="mt-2 font-display font-bold text-lg text-white uppercase">
                  Rango: Tango
                </div>
                <div className="mt-2 h-1.5 rounded-full bg-[#3E4D36]/50 overflow-hidden">
                  <div className="h-full w-[60%] bg-[#BEDD7D]" />
                </div>
                <div className="mt-1 text-[10px] font-body text-white/50">60% hacia Charlie</div>
              </div>
              {/* Cards */}
              <div className="flex-1 p-4 space-y-3 overflow-hidden">
                <div className="p-3 rounded-xl bg-[#1A2E1A]/60 border border-[#3E4D36]/50">
                  <div className="flex items-center justify-between">
                    <span className="text-[9px] font-display uppercase tracking-widest text-[#BEDD7D]">
                      Señal activa
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#BEDD7D] animate-pulse" />
                  </div>
                  <div className="mt-2 flex items-baseline justify-between">
                    <span className="font-display font-bold text-white">EUR/USD</span>
                    <span className="text-[#BEDD7D] font-display text-sm">+24 pips</span>
                  </div>
                </div>
                <div className="p-3 rounded-xl bg-[#1A2E1A]/60 border border-[#3E4D36]/50">
                  <div className="text-[9px] font-display uppercase tracking-widest text-white/50">
                    Wallet
                  </div>
                  <div className="mt-1 font-display font-bold text-2xl text-white">
                    $1.248<span className="text-[#BEDD7D] text-sm">.50</span>
                  </div>
                  <div className="text-[10px] font-body text-white/50">+$89 esta semana</div>
                </div>
                <div className="p-3 rounded-xl bg-gradient-to-br from-[#BEDD7D]/20 to-transparent border border-[#BEDD7D]/30">
                  <div className="text-[9px] font-display uppercase tracking-widest text-[#BEDD7D]">
                    Próxima Misión
                  </div>
                  <div className="mt-1 text-sm font-body text-white/90">
                    3 setups ganadores en XAU/USD
                  </div>
                </div>
              </div>
              {/* Tab bar */}
              <div className="px-6 py-4 border-t border-[#3E4D36]/30 flex items-center justify-between">
                <div className="w-1.5 h-1.5 rounded-full bg-[#BEDD7D]" />
                <div className="w-1.5 h-1.5 rounded-full bg-white/20" />
                <div className="w-1.5 h-1.5 rounded-full bg-white/20" />
                <div className="w-1.5 h-1.5 rounded-full bg-white/20" />
                <div className="w-1.5 h-1.5 rounded-full bg-white/20" />
              </div>
            </div>
          </div>
          {/* Glow */}
          <div
            className="absolute -z-10 inset-0 blur-3xl opacity-50"
            style={{
              background: "radial-gradient(circle at 50% 50%, rgba(190,221,125,0.3), transparent 60%)",
            }}
          />
        </motion.div>
      </div>
    </section>
  );
}
